export enum ImportFieldFormatType {
  FILE_TYPE_TXT = 'text/plain',
  FILE_TYPE_HTML = 'text/html',
}
